const{MinimogThemeStyles,MinimogThemeScripts}=window;class QuickView{constructor(){this.modal=new MinimogTheme.Modal;this.isOpen=false;this.isLoading=false;this.initialize()}initialize(){
// Use event delegation for better performance
this.setupEventListeners();
// Subscribe to cart update events - use once to prevent memory leaks
window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate,this.handleCartUpdate.bind(this))}setupEventListeners(){
// Event delegation for quick view button
addEventDelegate({selector:".m-product-quickview-button",handler:this.handleQuickViewClick.bind(this)});
// Event delegation for variant selection
addEventDelegate({
  selector: ".product-variations-block-item",
  context: document.body,
  handler: (e, target) => {
    // Only run if inside Quick View modal
    if (this.isOpen && this.modalContent.contains(target)) {
      this.handleVariantClick(e, target);
    }
    // Otherwise, let normal click behavior happen (like going to the product URL)
  }
})

}
handleQuickViewClick(e, target) {
  e.preventDefault();

  // Prevent multiple fast clicks
  if (this.isLoading || this.isTransitioning) return;

  this.isLoading = true;
  this.target = target;
  const productHandle = target.dataset.productHandle;

  // Close modal first if it's already open
  if (this.isOpen) {
    this.isTransitioning = true;

    this.modal.close(); // Close current modal
    this.isOpen = false;

    // Add a small delay to ensure it's fully closed before loading again
    setTimeout(() => {
      this.isTransitioning = false;
      if (productHandle) {
        this.toggleLoading(true);
        this.loadProductQuickView(productHandle);
      }
    }, 300); // Adjust based on your modal close animation duration
  } else {
    this.toggleLoading(true);
    if (productHandle) this.loadProductQuickView(productHandle);
  }
}

                                                                     
handleVariantClick(e,target){if(!this.isOpen||target.classList.contains('active')||this.isLoading)return;e.preventDefault();this.target=target;this.toggleLoading(true);const productHandle=target.dataset.productHandle;if(productHandle)this.loadVariantQuickView(productHandle)}handleCartUpdate(){if(this.modal)this.close()}
// Load variant quick view without closing modal
loadVariantQuickView(productHandle){if(this.isLoading)return;this.isLoading=true;
// Use fetch directly for better performance and control
fetch(`${window.MinimogSettings.base_url}products/${productHandle}?section_id=product-quickview`).then(response=>response.text()).then(responseText=>{
// Create a document fragment instead of a full DOM to improve performance
const parser=new DOMParser;const doc=parser.parseFromString(responseText,'text/html');const newContent=doc.querySelector(".m-product-quickview");if(this.modalContent&&newContent){
// Use targeted updates instead of full content replacement
this.updateModalContent(newContent)}this.isLoading=false;this.toggleLoading(false);
// Use requestAnimationFrame to delay UI work until the next paint
requestAnimationFrame(()=>{this.reinitializeComponents()})})["catch"](error=>{console.error("Error loading variant quick view:",error);this.isLoading=false;this.toggleLoading(false)})}updateModalContent(newContent){
// Update only necessary parts to minimize DOM operations
this.updateElement('.m-product-quickview--media',newContent);this.updateElement('.m-product-quickview--info',newContent);this.updateElement('#productData',newContent)}updateElement(selector,newContent){const currentElement=this.modalContent.querySelector(selector);const newElement=newContent.querySelector(selector);if(currentElement&&newElement){
// Use replaceWith for better performance than innerHTML
currentElement.replaceWith(newElement.cloneNode(true))}}
// Optimize component reinitialization
reinitializeComponents(){
// Use efficient, targeted component initialization
this.reinitializeComponent("media-gallery","reinit");this.reinitializeComponent("product-form","updateView");this.reinitializeComponent("variant-picker","updateOptions");this.reinitializeComponent("m-product-inventory","updateView");
// Use a single event dispatch
document.dispatchEvent(new CustomEvent("product:variant-change",{detail:{container:this.modalContent}}))}reinitializeComponent(selector,methodName){const elements=this.modalContent.querySelectorAll(selector);if(!elements.length)return;elements.forEach(element=>{if(element&&typeof element[methodName]==='function'){element[methodName]()}})}
// Load product quick view HTML
loadProductQuickView(productHandle){if(this.isOpen){this.close();// Close any existing modal before loading a new one
}this.isLoading=true;
// Load CSS before content for better perceived performance
this.loadAssets([MinimogThemeStyles.product,MinimogThemeStyles.productInventory],"quick-view-assets").then(()=>{return fetch(`${window.MinimogSettings.base_url}products/${productHandle}?section_id=product-quickview`).then(response=>response.text())}).then(responseText=>{const parser=new DOMParser;const doc=parser.parseFromString(responseText,'text/html');this.modalContent=doc.querySelector(".m-product-quickview");const firstModel=doc.querySelector("product-model");
// Load JS assets in parallel for better performance
return this.loadAssets([MinimogThemeScripts.productMedia,MinimogThemeScripts.variantsPicker,MinimogThemeScripts.productInventory],"variants-picker").then(()=>{
// Append modal content and initialize UI
const colorScheme=this.modalContent.dataset.colorScheme;this.modal.appendChild(this.modalContent);this.modal.setWidth("960px");this.modal.open();this.modal.setSizes(`m-gradient ${colorScheme}`);this.isOpen=true;this.isLoading=false;this.toggleLoading(false);
// Only load 3D model assets if needed
if(firstModel){return this.loadAssets([MinimogThemeScripts.productModel,"https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"],"product-model-assets")}})}).then(()=>{
// Notify other components of quick view load
document.dispatchEvent(new CustomEvent("quick-view:loaded",{detail:{productUrl:productHandle}}))})["catch"](error=>{console.error("Error loading product quick view:",error);this.isLoading=false;this.toggleLoading(false)})}
// Optimized asset loading with caching
loadAssets(assets,key){
// Check if assets are already loaded
if(window.loadedAssets&&window.loadedAssets[key]){return Promise.resolve()}return new Promise((resolve,reject)=>{loadAssetsNew(assets,key,resolve,reject)})}
// Close the quick view modal
close(e){if(!this.isOpen)return;this.modal.close(e);this.isOpen=false}
// Toggle loading spinner with debouncing
toggleLoading(isLoading){
// Cancel any pending toggle to prevent flicker
if(this._loadingTimeout){clearTimeout(this._loadingTimeout)}
// Short delay before showing loading state to prevent flicker
this._loadingTimeout=setTimeout(()=>{
// Apply loading state to target button
if(this.target){this.target.classList.toggle("m-spinner-loading",isLoading)}
// Apply loading state to modal
if(this.isOpen&&this.modalContent){this.modalContent.classList.toggle("is-loading",isLoading)}},isLoading?50:0);// Small delay when showing, no delay when hiding
}}
// Initialize the QuickView instance
MinimogTheme.ProductQuickView=new QuickView;